import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Stream from 'flarum/common/utils/Stream';
// @ts-ignore — lodash-es does not ship its own declaration files
import throttle from 'lodash-es/throttle';
import TypingIndicator from '../../components/TypingIndicator';
import TypingState from '../../states/TypingState';
export default function () {
  extend('flarum/forum/components/PostStream', 'endItems', function (items) {
    if (this.discussion.attribute('canViewWhoTypes') && this.discussion.typingState) {
      // Added as a named item so themes and extensions can grab it —
      // `items.remove('typingIndicator')` — and render a fresh <TypingIndicator> wherever
      // they like (reading the state from `discussion.typingState`), choosing their own
      // keying for that context.
      //
      // In this default placement the item is spread into PostStream's keyed children
      // (alongside the posts, load-more and reply placeholder), so it needs a key here too,
      // otherwise Mithril throws on the mixed keyed/unkeyed fragment.
      items.add('typingIndicator', m(TypingIndicator, {
        key: "typingIndicator",
        state: this.discussion.typingState
      }), 70);
    }
  });
  extend('flarum/forum/components/PostStream', 'oninit', function () {
    this.previousContent = Stream('');
    this.typingListener = null;

    // The state lives on the discussion model so it can be reached anywhere in the
    // discussion layout (e.g. `app.current.get('discussion')?.typingState`) without a
    // reference to this PostStream. PostStream owns its lifecycle — see onremove.
    this.discussion.typingState = new TypingState();
    this.actorIsTyping = () => {
      var _app$session$user, _app$websocket_channe, _app$session$user2;
      const discloseOnline = (_app$session$user = app.session.user) == null || (_app$session$user = _app$session$user.preferences()) == null ? void 0 : _app$session$user.discloseOnline;
      (_app$websocket_channe = app.websocket_channels.discussion) == null || _app$websocket_channe.trigger('client-typing', {
        displayName: discloseOnline ? (_app$session$user2 = app.session.user) == null ? void 0 : _app$session$user2.displayName() : '[anonymous]',
        discloseOnline,
        time: Date.now()
      });
    };
    this.checkTyping = () => {
      var _fields, _fields$content;
      if (!app.composer.composingReplyTo(this.discussion)) return;
      const currentContent = (_fields = app.composer.fields) == null || (_fields$content = _fields.content) == null ? void 0 : _fields$content.call(_fields);
      if (this.previousContent() !== currentContent) {
        this.actorIsTyping();
        this.previousContent(currentContent);
      }
    };
  });
  extend('flarum/forum/components/PostStream', 'view', function () {
    if (app.forum.attribute('websocket.disallow_connection')) return;
    if (this.discussion && app.composer.editor && !this.typingListener) {
      const checkFn = throttle(() => this.checkTyping(), 2000);
      this.typingListener = setInterval(checkFn, 1000);
    }
    if (this.discussion) {
      app.websocket_channels.discussion = app.websocket.subscribe('private-typing=' + m.route.param('id').match(/[0-9]+/));
      if (this.discussion.attribute('canViewWhoTypes')) {
        app.websocket_channels.discussion.bind('client-typing', data => {
          var _this$discussion$typi;
          (_this$discussion$typi = this.discussion.typingState) == null || _this$discussion$typi.add(data);
        });
      }
    }
  });
  extend('flarum/forum/components/PostStream', 'onremove', function () {
    var _this$discussion$typi2;
    if (this.typingListener) clearInterval(this.typingListener);
    (_this$discussion$typi2 = this.discussion.typingState) == null || _this$discussion$typi2.dispose();
    // Don't leave runtime state lingering on the cached discussion model.
    delete this.discussion.typingState;
  });
}